import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
var _excluded = ["autoplay", "delay", "type", "repeat", "repeatDelay", "repeatType", "keyframes", "name", "motionValue", "element"];
import "core-js/modules/es.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { MotionGlobalConfig, noop } from 'motion-utils';
import { time } from '../frameloop/sync-time.mjs';
import { JSAnimation } from './JSAnimation.mjs';
import { getFinalKeyframe } from './keyframes/get-final.mjs';
import { KeyframeResolver, flushKeyframeResolvers } from './keyframes/KeyframesResolver.mjs';
import { NativeAnimationExtended } from './NativeAnimationExtended.mjs';
import { canAnimate } from './utils/can-animate.mjs';
import { WithPromise } from './utils/WithPromise.mjs';
import { supportsBrowserAnimation } from './waapi/supports/waapi.mjs';
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */

var MAX_RESOLVE_DELAY = 40;

var AsyncMotionValueAnimation = /*#__PURE__*/function (_WithPromise) {
  _inherits(AsyncMotionValueAnimation, _WithPromise);

  var _super = _createSuper(AsyncMotionValueAnimation);

  function AsyncMotionValueAnimation(_ref) {
    var _this$keyframeResolve2;

    var _this;

    var _ref$autoplay = _ref.autoplay,
        autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay,
        _ref$delay = _ref.delay,
        delay = _ref$delay === void 0 ? 0 : _ref$delay,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? "keyframes" : _ref$type,
        _ref$repeat = _ref.repeat,
        repeat = _ref$repeat === void 0 ? 0 : _ref$repeat,
        _ref$repeatDelay = _ref.repeatDelay,
        repeatDelay = _ref$repeatDelay === void 0 ? 0 : _ref$repeatDelay,
        _ref$repeatType = _ref.repeatType,
        repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType,
        keyframes = _ref.keyframes,
        name = _ref.name,
        motionValue = _ref.motionValue,
        element = _ref.element,
        options = _objectWithoutProperties(_ref, _excluded);

    _classCallCheck(this, AsyncMotionValueAnimation);

    _this = _super.call(this);
    /**
     * Bound to support return animation.stop pattern
     */

    _this.stop = function () {
      var _this$keyframeResolve;

      if (_this._animation) {
        var _this$stopTimeline, _this2;

        _this._animation.stop();

        (_this$stopTimeline = (_this2 = _this).stopTimeline) === null || _this$stopTimeline === void 0 ? void 0 : _this$stopTimeline.call(_this2);
      }

      (_this$keyframeResolve = _this.keyframeResolver) === null || _this$keyframeResolve === void 0 ? void 0 : _this$keyframeResolve.cancel();
    };

    _this.createdAt = time.now();

    var optionsWithDefaults = _objectSpread({
      autoplay: autoplay,
      delay: delay,
      type: type,
      repeat: repeat,
      repeatDelay: repeatDelay,
      repeatType: repeatType,
      name: name,
      motionValue: motionValue,
      element: element
    }, options);

    var KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || KeyframeResolver;
    _this.keyframeResolver = new KeyframeResolver$1(keyframes, function (resolvedKeyframes, finalKeyframe, forced) {
      return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced);
    }, name, motionValue, element);
    (_this$keyframeResolve2 = _this.keyframeResolver) === null || _this$keyframeResolve2 === void 0 ? void 0 : _this$keyframeResolve2.scheduleResolve();
    return _this;
  }

  _createClass(AsyncMotionValueAnimation, [{
    key: "onKeyframesResolved",
    value: function onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
      var _this3 = this;

      this.keyframeResolver = undefined;
      var name = options.name,
          type = options.type,
          velocity = options.velocity,
          delay = options.delay,
          isHandoff = options.isHandoff,
          onUpdate = options.onUpdate;
      this.resolvedAt = time.now();
      /**
       * If we can't animate this value with the resolved keyframes
       * then we should complete it immediately.
       */

      if (!canAnimate(keyframes, name, type, velocity)) {
        if (MotionGlobalConfig.instantAnimations || !delay) {
          onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(getFinalKeyframe(keyframes, options, finalKeyframe));
        }

        keyframes[0] = keyframes[keyframes.length - 1];
        options.duration = 0;
        options.repeat = 0;
      }
      /**
       * Resolve startTime for the animation.
       *
       * This method uses the createdAt and resolvedAt to calculate the
       * animation startTime. *Ideally*, we would use the createdAt time as t=0
       * as the following frame would then be the first frame of the animation in
       * progress, which would feel snappier.
       *
       * However, if there's a delay (main thread work) between the creation of
       * the animation and the first commited frame, we prefer to use resolvedAt
       * to avoid a sudden jump into the animation.
       */


      var startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;

      var resolvedOptions = _objectSpread(_objectSpread({
        startTime: startTime,
        finalKeyframe: finalKeyframe
      }, options), {}, {
        keyframes: keyframes
      });
      /**
       * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
       * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
       * optimised animation.
       */


      var animation = !isHandoff && supportsBrowserAnimation(resolvedOptions) ? new NativeAnimationExtended(_objectSpread(_objectSpread({}, resolvedOptions), {}, {
        element: resolvedOptions.motionValue.owner.current
      })) : new JSAnimation(resolvedOptions);
      animation.finished.then(function () {
        return _this3.notifyFinished();
      }).catch(noop);

      if (this.pendingTimeline) {
        this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
        this.pendingTimeline = undefined;
      }

      this._animation = animation;
    }
  }, {
    key: "finished",
    get: function get() {
      if (!this._animation) {
        return this._finished;
      } else {
        return this.animation.finished;
      }
    }
  }, {
    key: "then",
    value: function then(onResolve, _onReject) {
      return this.finished.finally(onResolve).then(function () {});
    }
  }, {
    key: "animation",
    get: function get() {
      if (!this._animation) {
        var _this$keyframeResolve3;

        (_this$keyframeResolve3 = this.keyframeResolver) === null || _this$keyframeResolve3 === void 0 ? void 0 : _this$keyframeResolve3.resume();
        flushKeyframeResolvers();
      }

      return this._animation;
    }
  }, {
    key: "duration",
    get: function get() {
      return this.animation.duration;
    }
  }, {
    key: "time",
    get: function get() {
      return this.animation.time;
    },
    set: function set(newTime) {
      this.animation.time = newTime;
    }
  }, {
    key: "speed",
    get: function get() {
      return this.animation.speed;
    },
    set: function set(newSpeed) {
      this.animation.speed = newSpeed;
    }
  }, {
    key: "state",
    get: function get() {
      return this.animation.state;
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.animation.startTime;
    }
  }, {
    key: "attachTimeline",
    value: function attachTimeline(timeline) {
      var _this4 = this;

      if (this._animation) {
        this.stopTimeline = this.animation.attachTimeline(timeline);
      } else {
        this.pendingTimeline = timeline;
      }

      return function () {
        return _this4.stop();
      };
    }
  }, {
    key: "play",
    value: function play() {
      this.animation.play();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.animation.pause();
    }
  }, {
    key: "complete",
    value: function complete() {
      this.animation.complete();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this$keyframeResolve4;

      if (this._animation) {
        this.animation.cancel();
      }

      (_this$keyframeResolve4 = this.keyframeResolver) === null || _this$keyframeResolve4 === void 0 ? void 0 : _this$keyframeResolve4.cancel();
    }
  }]);

  return AsyncMotionValueAnimation;
}(WithPromise);

export { AsyncMotionValueAnimation };